import React from 'react'
import Dialog from "@mui/material/Dialog";
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import Button from '@mui/material/Button';
import DialogActions from '@mui/material/DialogActions';
import Paper from '@mui/material/Paper';
import Draggable from 'react-draggable'
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';

function PaperComponent(props) {

  return (
    <Draggable bounds="parent">
      <Paper {...props} />
    </Draggable>
  )
}

const DraggableDialog = ({ title, content, open, onClose, cancelButtonText = 'Close', confirmText, onCallbackAction }) => {

  const handleClose = (event, reason) => {
    if (reason && reason === "backdropClick") {
      return;
    }
    onClose();
  };


  const handleCallback = () => {
    onCallbackAction();
  };

  return (

    <Dialog
      hideBackdrop
      disableEnforceFocus
      style={{ position: 'top', pointerEvents: 'none' }}
      open={open}
      onClose={handleClose}
      PaperComponent={PaperComponent}
      aria-labelledby="draggable-dialog-title"
      disableBackdropClick
      PaperProps={{
        style: { borderRadius: 5, pointerEvents: 'auto' }
      }}
      maxWidth={'xs'}
      fullWidth={true}
    >
      <DialogTitle id="draggable-dialog-title">
        {title}
        {onClose ? (
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        ) : null}
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          {content}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button variant="contained"
          sx={{
            color: '#333330',
            backgroundColor: '#82C027',
            boxShadow: '0px 1px 2px #6F7687',
            borderRadius: '5px',
            textTransform: 'none',
            '&:hover': {
              backgroundColor: '#82C027',
              boxShadow: 'none'
            }
          }}
          onClick={handleClose}>
          {cancelButtonText}
        </Button>
        {confirmText && (
          <Button variant="contained"
            sx={{
              color: '#333330',
              backgroundColor: '#82C027',
              boxShadow: '0px 1px 2px #6F7687',
              borderRadius: '5px',
              textTransform: 'none',
              '&:hover': {
                backgroundColor: '#82C027',
                boxShadow: 'none'
              }
            }}
            onClick={handleCallback}>
            {confirmText}
          </Button>
        )
        }
      </DialogActions>
    </Dialog>

  )
}

export default DraggableDialog
